import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Toastでメッセージを表示する
 * @export
 * @class ToastMessageService
 */
@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {

  /**
   * エラーメッセージを蓄えるプロパティ
   */
  private _errorResult$ = new Subject<string>();

  constructor() {
    this._errorResult$.next("");
  }

  // エラーメッセージを取得するゲッター
  get errValueChages() {
    return this._errorResult$.asObservable();
  }

  /**
   * エラーのトーストメッセージを追加する
   * durationの指定がない場合は消えないメッセージになる
   *
   * @param {string} message
   * @memberof ToastMessageService
   */
  public addError(message: string): void
  public addError(message: string, duration: number): void

  /**
   * エラーのメッセージを追加する
   *
   * @param {string} message 表示するメッセージ
   * @param {number} [duration] メッセージ表示時間
   * @memberof ToastMessageService
   */
  public addError(message: string, duration?: number): void {

    // エラーメッセージをデータストリームに流す
    this._errorResult$.next(message);
  }

  /**
   * メッセージをクリアする
   *
   * @memberof ToastMessageService
   */
  public clear() {
    this._errorResult$.next("");
  }
}